<template>
  <v-container v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-form ref="form" validation @input="checkValidate" class="ml-3">
      <v-layout row>
        <v-flex xs12 lg12 md12>
          <h1 class="my-3">{{title}}</h1>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12 lg8 md8>
          <v-text-field
              label="Наименование мониторинга"
              v-model="monitoringTitle"
              :rules="monitoringTitleRules"
              validate-on-blur
              outline
              @input="checkValidate"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12 lg8 md8>
          <v-layout row>
            <v-flex xs6 lg6 md6 class="mr-4">
              <v-text-field
                  label="Не чаще чем раз в N дней"
                  v-model="frequency"
                  :rules="monitoringNumericRules"
                  validate-on-blur
                  outline
                  suffix=""
                  @input="checkValidate"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 lg6 md6>
              <v-text-field
                  label="Максимальное число проверок"
                  v-model="max_checks"
                  validate-on-blur
                  outline
                  suffix=""
                  @input="checkValidate"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout row class="pa-0 ma-0">
        <v-flex xs12 lg8 md8>
          <v-radio-group v-model="isRequired" row>
            <v-radio label="Обязательная проверка" value="1"></v-radio>
            <v-radio label="Необязательная проверка" value="0"></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>

      <p class="title">Каналы продаж</p>
      <v-layout
        row
        v-if="channelList.length > 0"
        class="mb-4"
      >
        <v-flex xs12 lg8 md8 pa-3 class="elevation-1 white">
          <div
            v-for="(channel, index) in channelList"
            :key="channel.id"
          >
            <v-checkbox
              :label="channel.title"
              v-model="channelList[index].checked"
              class="ma-0 pa-0"
              @change="onChannelChanged"
            ></v-checkbox>
          </div>
        </v-flex>
      </v-layout>

      <p class="title">Торговые точки</p>
      <v-layout row class="mb-3">
        <v-flex xs12 lg8 md8 pa-3 class="elevation-1 white">
          <v-progress-circular
              v-if="pointLoading"
              :size="50"
              color="primary"
              indeterminate
          ></v-progress-circular>
          <div v-if="pointTreeData.length > 0 && !pointLoading">
            <tree
                :data="pointTreeData"
                :options="{
                checkbox: true,
                fetchData(node) {
                  return getPointFolder(node.data.id)
                },
                treeType: 'pointTree'
              }"
                class="tree--small"
                @node:checked="onPointChecked"
                @node:unchecked="onPointUnchecked"
            />
          </div>
        </v-flex>
      </v-layout>

      <p class="title mt-3">Товары и торговые точки</p>
      <v-layout row>
        <v-flex xs12 lg8 md8>
          <v-btn
            class="warning ma-0"
            @click="triggerUpload"
            :loading="uploading"
            :disabled="uploading"
          >
            Загрузить xls
            <v-icon right dark>cloud_upload</v-icon>
          </v-btn>
          <input
            ref="fileInput"
            type="file"
            style="display: none;"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            @change="onFileChange"
          >
          <div class="mt-1">
            <span class="font-weight-thin">Загруженный файл: </span>
            <span class="font-weight-thin">{{product_xls_path}}</span>
          </div>
        </v-flex>
      </v-layout>

      <v-layout row class="pa-0 mt-3 mb-3">
        <v-flex xs12 lg12 md12>
          <div class="float-left inline-block">
            <p class="title">Дата начала</p>
            <v-date-picker
                v-model="startDate"
                :reactive="true"
                locale="ru"
                class="mr-3 ml-0 mt-0 mb-3"
                :min="minDate()"
                @input="checkValidate()"
                :first-day-of-week="1"
            ></v-date-picker>
          </div>
          <div class="inline-block">
            <p class="title">Дата окончания</p>
            <v-date-picker
                v-model="endDate"
                :reactive="true"
                locale="ru"
                class="mr-3 ml-0"
                :min="minDate()"
                @input="checkValidate()"
                :first-day-of-week="1"
            ></v-date-picker>
          </div>
        </v-flex>
      </v-layout>

      <v-layout row class="pa-0 ma-0">
        <v-flex xs12 lg6 md6>
          <v-btn
            :loading="loading && !uploading"
            :disabled="!valid || loading || uploading"
            color="primary"
            @click.native="loader = 'loading'"
            class="ma-0"
            @click="onClickCreateMonitoring"
          >
            {{id === null ? 'Создать' : 'Изменить'}}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      breadcrumbs: [
        {name: 'Главная', link: '/'},
        {name: 'Мониторинги', link: '/monitorings/active'}
      ],
      pageDataReady: {
        isReady: false,
        distributionChannelList: false,
        points: false,
        products: false
      },
      pointFolderTree: [],
      channelIdList: [],
      channelList: [],
      pointListTreeData: [],
      pointFolderIdList: [],
      pointIdList: [],
      pointTreeData: [],
      pointTreeIdCounter: 0,
      pointLoading: false,
      uploading: false,
      product_xls: null,
      product_xls_path: 'не загружен',

      productCategoryTree: [],
      frequency: null,
      max_checks: null,
      isRequired: null,
      minOrderSum: null,
      minOrderWeight: null,
      refundPercent: null,
      id: null,
      title: 'Новый мониторинг',
      monitoringTitle: null,
      description: null,
      startDate: null,
      endDate: null,
      productTreeIdCounter: 0,
      productGroupList: [
        {
          id: 0,
          title: '',
          pointMinPercent: '',
          skuIdList: [],
          skuList: [],
          treeData: [],
          dialog: false,
          productTreeData: []
        }
      ],
      valid: false,
      monitoringTitleRules: [
        v => !!v || 'Обязательное поле'
      ],
      monitoringNumericRules: [
        v => /^[0-9.]+$/u.test(v) || 'Только числовое значение'
      ]
    }),
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.distributionChannelList) {
          return false
        }

        if (!this.pageDataReady.points) {
          return false
        }
        // if (!this.pageDataReady.products) {
        //   return false
        // }

        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      triggerUpload () {
        this.$refs.fileInput.click()
      },
      onFileChange (event) {
        this.product_xls = event.target.files[0]
        this.product_xls_path = this.product_xls.name
      },
      onSetTextProductGroup (index) {
        if (this.productGroupList[index].title === '' && this.productGroupList[index].pointMinPercent === '') {
          this.$delete(this.productGroupList, index)
        } else if (this.productGroupList.length - 1 === index) {
          this.productGroupList.push({
            id: 0,
            title: '',
            pointMinPercent: '',
            skuIdList: [],
            skuList: [],
            dialog: false,
            productTreeData: []
          })

          this.getProductCategory(index + 1)
            .then((data) => {
              this.productGroupList[index + 1].productTreeData = data
            })
            .catch((e) => {
              console.log(e)
            })
        }
      },
      onChannelChanged () {
        let pointTree = null
        for (let i = 0; i < this.$refs.form.$children.length; i++) {
          if (typeof this.$refs.form.$children[i].tree !== 'undefined') {
            if (this.$refs.form.$children[i].options.treeType === 'pointTree') {
              pointTree = this.$refs.form.$children[i].model
            }
          }
        }

        this.channelIdList = []
        for (let i = 0; i < this.channelList.length; i++) {
          if (this.channelList[i].checked) {
            this.channelIdList.push(this.channelList[i].id)
          }
        }

        this.pointFolderExpanded = []
        this.pointFolderTree = this.fillPointFolderTree(pointTree)
        console.log(this.pointFolderExpanded)
        console.log(this.pointFolderTree)
        this.pointTreeLoader()
      },
      fillPointFolderTree (tree) {
        let folders = []
        if (!tree) {
          return []
        }
        for (let i = 0; i < tree.length; i++) {
          if (tree[i].data.type === 'folder') {
            console.log(tree[i].data.id, tree[i].data.text, tree[i].states)
            if (tree[i].states.indeterminate || tree[i].states.checked) {
              folders.push({
                id: tree[i].data.id,
                point_folder_list: this.fillPointFolderTree(tree[i].children),
                point_list: this.fillPointTree(tree[i].children)
              })
            } else if (tree[i].states.expanded) {
              this.pointFolderExpanded.push(tree[i].data.id)
              this.fillPointFolderTree(tree[i].children)
            }
          }
        }
        return folders
      },
      fillPointTree (tree) {
        let points = []
        for (let i = 0; i < tree.length; i++) {
          if (tree[i].data.type === 'point') {
            if (tree[i].states.checked) {
              points.push({
                id: tree[i].data.id
              })
            }
          }
        }
        return points
      },
      onPointChecked (node) {
        if (node.data.type === 'folder' && !~this.pointFolderIdList.indexOf(node.data.id)) {
          this.pointFolderIdList.push(node.data.id)
        }
        if (node.data.type === 'point' && !~this.pointIdList.indexOf(node.data.id)) {
          this.pointIdList.push(node.data.id)
        }
      },
      onPointUnchecked (node) {
        if (node.data.type === 'folder') {
          let position = this.pointFolderIdList.indexOf(node.data.id)
          if (~position) this.pointFolderIdList.splice(position, 1)
          for (let i = 0; i < node.children.length; i++) {
            if (node.children[i].states.checked) {
              if (node.children[i].data.type === 'folder') {
                let position = this.pointFolderIdList.indexOf(node.children[i].data.id)
                if (!~position) this.pointFolderIdList.push(node.children[i].data.id)
              }
              if (node.children[i].data.type === 'point') {
                let position = this.pointIdList.indexOf(node.children[i].data.id)
                if (!~position) this.pointIdList.push(node.children[i].data.id)
              }
            }
          }
        }
        if (node.data.type === 'point') {
          let position = this.pointIdList.indexOf(node.data.id)
          if (~position) this.pointIdList.splice(position, 1)
        }
      },
      onProductSkuChecked (node) {
        if (node.data.type === 'sku' && !~this.productGroupList[node.data.groupIndex].skuIdList.indexOf(node.data.id)) {
          this.productGroupList[node.data.groupIndex].skuIdList.push(node.data.id)
          this.productGroupList[node.data.groupIndex].skuList.push(node.data.text)
        }
      },
      onProductSkuUnchecked (node) {
        if (node.data.type === 'sku') {
          let position = this.productGroupList[node.data.groupIndex].skuIdList.indexOf(node.data.id)
          if (~position) {
            this.productGroupList[node.data.groupIndex].skuIdList.splice(position, 1)
            this.productGroupList[node.data.groupIndex].skuList.splice(position, 1)
          }
        }
      },
      onClickSkuSelectBtn (productGroupIndex) {
        this.productGroupList[productGroupIndex].dialog = true
      },
      async onClickCreateMonitoring () {
        let pointTree = null
        for (let i = 0; i < this.$refs.form.$children.length; i++) {
          if (typeof this.$refs.form.$children[i].tree !== 'undefined') {
            if (this.$refs.form.$children[i].options.treeType === 'pointTree') {
              pointTree = this.$refs.form.$children[i].model
            }
          }
        }

        this.filterChildrenPointIdList(pointTree)

        let monitoringData = {
          id: this.id,
          title: this.monitoringTitle,
          max_checks: this.max_checks,
          frequency: this.frequency,
          isRequired: this.isRequired,
          startDate: this.startDate + ' 00:00:00',
          endDate: this.endDate + ' 00:00:00'
        }

        if (this.product_xls !== null) {
          monitoringData.productXls = this.product_xls
        }

        if (this.pointFolderIdList.length > 0) {
          monitoringData.pointFolderIdList = this.pointFolderIdList
        }
        if (this.pointIdList.length > 0) {
          monitoringData.pointIdList = this.pointIdList
        }

        if (this.productGroupList.length > 1) {
          monitoringData.productGroupList = []
          for (let i = 0; i < this.productGroupList.length - 1; i++) {
            monitoringData.productGroupList[i] = {
              id: this.productGroupList[i].id,
              title: this.productGroupList[i].title,
              product_sku_id_list: this.productGroupList[i].skuIdList
            }
          }
        }

        this.channelIdList = []
        for (let i = 0; i < this.channelList.length; i++) {
          if (this.channelList[i].checked) {
            this.channelIdList.push(this.channelList[i].id)
          }
        }

        if (this.channelIdList.length > 0) {
          monitoringData.channelIdList = this.channelIdList
        }

        await this.$store.dispatch('createMonitoring', monitoringData)
          .then((data) => {
            if (typeof data.monitoring !== 'undefined') {
              this.$router.push('/monitorings/single/' + data.monitoring.id)
            }
          })
          .catch((e) => {
            console.log(e)
          })
      },
      minDate () {
        let date = new Date()
        date.setHours(24)
        return this.$moment(date).format('YYYY-MM-DD')
      },
      checkValidate () {
        if (this.startDate === null) {
          this.valid = false
        } else if (this.endDate === null) {
          this.valid = false
        } else if (this.startDate > this.endDate) {
          this.valid = false
        } else if (this.monitoringTitle === null || this.monitoringTitle === '') {
          this.valid = false
        } else if (this.frequency === null) {
          this.valid = false
        } else if (this.max_checks === null) {
          this.valid = false
        } else if (this.product_xls === null && this.id === null) {
          this.valid = false
        } else {
          this.valid = true
        }
        return this.valid
      },
      onCreated () {
        this.$store.commit('setPageLoading', true)

        this.id = null
        this.channelList = []
        this.monitoringTitle = null
        this.description = null
        this.frequency = null
        this.max_checks = null
        this.isRequired = null
        this.startDate = null
        this.endDate = null
        this.pointListTreeData = []
        this.pointFolderIdList = []
        this.pointIdList = []
        this.pointTreeData = []
        this.pointFolderExpanded = []
        this.pointTreeIdCounter = 0

        this.breadcrumbs = [
          {name: 'Главная', link: '/'},
          {name: 'Мониторинги', link: '/monitorings/active'}
        ]

        if (this.$router.currentRoute.path.indexOf('/monitorings/edit/') !== -1) {
          this.id = parseInt(this.$route.params.id)
          this.title = 'Редактировать мониторинг'
          this.$store.dispatch('getMonitoringSingle', {id: this.id})
          this.breadcrumbs.push({name: 'Редактировать мониторинг'})
        } else {
          this.id = null
          this.title = 'Новый мониторинг'
          this.breadcrumbs.push({name: 'Новый мониторинг'})

          this.$store.dispatch('getDistributionChannelList')
            .then(() => {
              this.pageDataReady.distributionChannelList = true
              this.pageDataStatus()
            })

          this.getPointFolder(0)
            .then((data) => {
              this.pointTreeData = data
              this.pageDataReady.points = true
              this.pageDataStatus()
            })
            .catch((e) => {
              console.log(e)
            })

          this.getProductCategory(0)
            .then((data) => {
              this.productGroupList[0].productTreeData = data
              this.pageDataReady.products = true
              this.pageDataStatus()
            })
            .catch((e) => {
              console.log(e)
            })
        }
        this.$store.commit('setPageTitle', this.title)
      },
      async getPointFolder (nodeId) {
        let folder

        await this.$store.dispatch('getPointFolderList', {id: nodeId, mode: 'active', channelIdList: this.channelIdList})
          .then((data) => {
            if (this.id !== null && this.monitoringData !== null) {
              folder = this.pointTreeDataStructure([data], false, this.pointFolderTree)[0].children
            } else {
              folder = this.pointTreeDataStructure([data])[0].children
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return folder
      },
      async getProductCategory (groupIndex) {
        let categoryList = []
        await this.$store.dispatch('getProductCategoryList')
          .then((data) => {
            for (let i = 0; i < data.product_category_list.length; i++) {
              categoryList[i] = {
                text: data.product_category_list[i].title,
                data: {
                  id: data.product_category_list[i].id,
                  type: 'category',
                  groupIndex: groupIndex
                },
                id: this.productTreeIdCounter++,
                isBatch: true
              }
              categoryList[i].state = { checkbox: false }
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return categoryList
      },
      async getProductBrand (categoryId, groupIndex) {
        let brandList = []
        await this.$store.dispatch('getProductBrandList', {id: categoryId})
          .then((data) => {
            for (let i = 0; i < data.product_category_brand_list.length; i++) {
              brandList[i] = {
                text: data.product_category_brand_list[i].title,
                data: {
                  id: data.product_category_brand_list[i].id,
                  productBrandId: data.product_category_brand_list[i].product_brand_id,
                  type: 'brand',
                  groupIndex: groupIndex
                },
                id: this.productTreeIdCounter++,
                isBatch: true
              }
              brandList[i].state = { checkbox: false }
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return brandList
      },
      async getProductSku (brandId, groupIndex) {
        let skuList = []
        await this.$store.dispatch('getProductSkuList', {id: brandId})
          .then((data) => {
            for (let i = 0; i < data.product_sku_list.length; i++) {
              skuList[i] = {
                text: data.product_sku_list[i].title,
                data: {
                  id: data.product_sku_list[i].id,
                  type: 'sku',
                  groupIndex: groupIndex
                },
                id: this.productTreeIdCounter++,
                isBatch: false
              }

              let productIdPosition = this.productGroupList[groupIndex].skuIdList.indexOf(data.product_sku_list[i].id)
              let productChecked = false
              if (~productIdPosition) {
                productChecked = true
              }
              skuList[i].state = { checked: productChecked, checkbox: true }
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return skuList
      },
      isChildrenInPointTree (id, tree) {
        if (tree !== null && typeof tree !== 'undefined') {
          for (let i = 0; i < tree.length; i++) {
            let isId = tree[i].id === id
            let isFolders = typeof tree[i].point_folder_list !== 'undefined'
            let isPoints = typeof tree[i].point_list !== 'undefined'

            if (isId && (isFolders || isPoints)) {
              return true
            } else if (isFolders) {
              if (this.isChildrenInPointTree(id, tree[i].point_folder_list)) {
                return true
              }
            }
          }
        }
        return false
      },
      pointTreeDataStructure (pointFolderList, folderChecked = false, indeterminateTree = null) {
        let resultList = []

        for (let i = 0; i < pointFolderList.length; i++) {
          resultList[i] = {}

          if (typeof pointFolderList[i].title !== 'undefined') {
            resultList[i].text = pointFolderList[i].title
          }

          if (typeof pointFolderList[i].id !== 'undefined') {
            resultList[i].data = {
              id: pointFolderList[i].id,
              type: 'folder'
            }
            resultList[i].id = this.pointTreeIdCounter++
            resultList[i].isBatch = pointFolderList[i].have_children
          }

          let folderIdPosition = this.pointFolderIdList.indexOf(pointFolderList[i].id)
          let currentFolderChecked = false
          if (~folderIdPosition || folderChecked) {
            currentFolderChecked = true
          }
          resultList[i].state = { checked: currentFolderChecked }

          if (!currentFolderChecked && indeterminateTree !== null) {
            resultList[i].state.indeterminate = this.isChildrenInPointTree(pointFolderList[i].id, indeterminateTree)
            resultList[i].state.expanded = this.isChildrenInPointTree(pointFolderList[i].id, indeterminateTree)
          }

          if (typeof pointFolderList[i].id !== 'undefined' && ~this.pointFolderExpanded.indexOf(resultList[i].data.id)) {
            resultList[i].state.expanded = true
          }

          if (typeof pointFolderList[i].point_folder_list !== 'undefined') {
            resultList[i].children = []
            resultList[i].children = this.pointTreeDataStructure(pointFolderList[i].point_folder_list, folderChecked, indeterminateTree)
          }

          if (typeof pointFolderList[i].point_list !== 'undefined') {
            if (typeof resultList[i].children === 'undefined') {
              resultList[i].children = []
            }

            for (let j = 0; j < pointFolderList[i].point_list.length; j++) {
              let index = resultList[i].children.length
              resultList[i].children[index] = {
                text: pointFolderList[i].point_list[j].title,
                data: {
                  id: pointFolderList[i].point_list[j].id,
                  type: 'point'
                }
              }
              let pointIdPosition = this.pointIdList.indexOf(pointFolderList[i].point_list[j].id)
              let pointChecked = false
              if (~pointIdPosition || currentFolderChecked) {
                pointChecked = true
              }
              resultList[i].children[index].state = { checked: pointChecked }
            }
          }
        }
        return resultList
      },
      filterChildrenPointIdList (tree, deleteThis = false) {
        for (let i = 0; i < tree.length; i++) {
          if (tree[i].data.type === 'folder') {
            let folderIdPosition = this.pointFolderIdList.indexOf(tree[i].data.id)
            if (~folderIdPosition) {
              if (deleteThis) {
                this.pointFolderIdList.splice(folderIdPosition, 1)
              }
              this.filterChildrenPointIdList(tree[i].children, true)
            } else {
              if (deleteThis) {
                this.filterChildrenPointIdList(tree[i].children, true)
              } else {
                this.filterChildrenPointIdList(tree[i].children, false)
              }
            }
          } else if (tree[i].data.type === 'point') {
            let pointIdPosition = this.pointIdList.indexOf(tree[i].data.id)
            if (~pointIdPosition && deleteThis) {
              this.pointIdList.splice(pointIdPosition, 1)
            }
          }
        }
      },
      async pointTreeLoader (id = 0) {
        this.pointLoading = true
        let pointTreeData = await this.$store.dispatch('getPointFolderList', {id: id, mode: 'active', channelIdList: this.channelIdList})
          .then((data) => {
            return data
          })
          .catch((e) => {
            console.log(e)
          })

        if (typeof pointTreeData.point_folder_list !== 'undefined') {
          for (let i = 0; i < pointTreeData.point_folder_list.length; i++) {
            if (
              this.isChildrenInPointTree(pointTreeData.point_folder_list[i].id, this.pointFolderTree) ||
              ~this.pointFolderExpanded.indexOf(pointTreeData.point_folder_list[i].id)
            ) {
              let child = await this.pointTreeLoader(pointTreeData.point_folder_list[i].id)
              pointTreeData.point_folder_list[i].point_folder_list = child.point_folder_list
              pointTreeData.point_folder_list[i].point_list = child.point_list
            }
          }
        }

        if (id === 0) {
          this.pointTreeData = this.pointTreeDataStructure([pointTreeData], false, this.pointFolderTree)[0].children
          this.pointLoading = false
          this.pageDataReady.points = true
          this.pageDataStatus()
        } else {
          return pointTreeData
        }
      }
    },
    computed: {
      loading () {
        return this.$store.getters.loading
      },
      monitoringData () {
        return this.$store.getters.monitoringSingle
      },
      distributionChannelList () {
        return this.$store.getters.distributionChannelList
      },
      productList () {
        return this.$store.getters.productList
      }
    },
    created () {
      this.onCreated()
    },
    watch: {
      '$route' (to, from) {
        this.onCreated()
      },
      monitoringData (newMonitoring, oldMonitoring) {
        if (this.monitoringData !== null && this.monitoringData !== undefined) {
          this.monitoringTitle = this.monitoringData.title
          this.startDate = this.$moment(this.monitoringData.start_date).format('YYYY-MM-DD')
          this.endDate = this.$moment(this.monitoringData.end_date).format('YYYY-MM-DD')
          this.frequency = this.monitoringData.frequency
          this.max_checks = this.monitoringData.max_checks
          this.isRequired = this.monitoringData.is_required ? '1' : '0'
          this.product_xls_path = this.monitoringData.product_xls_title
          this.pointFolderTree = this.monitoringData.point_folder_tree

          if (typeof this.monitoringData.distribution_channel_list !== 'undefined') {
            this.channelIdList = []
            for (let i = 0; i < this.monitoringData.distribution_channel_list.length; i++) {
              this.channelIdList.push(this.monitoringData.distribution_channel_list[i].id)
            }
          }

          if (typeof this.monitoringData.point_folder_list !== 'undefined') {
            this.pointFolderIdList = []
            for (let i = 0; i < this.monitoringData.point_folder_list.length; i++) {
              this.pointFolderIdList.push(this.monitoringData.point_folder_list[i].id)
            }
          }

          if (typeof this.monitoringData.point_list !== 'undefined') {
            this.pointIdList = []
            for (let i = 0; i < this.monitoringData.point_list.length; i++) {
              this.pointIdList.push(this.monitoringData.point_list[i].id)
            }
          }

          this.$store.dispatch('getDistributionChannelList')
            .then(() => {
              this.pageDataReady.distributionChannelList = true
              this.pageDataStatus()
            })

          this.pointTreeLoader()
        }
      },
      distributionChannelList (n, o) {
        this.channelList = []
        for (let i = 0; i < this.distributionChannelList.length; i++) {
          this.channelList[i] = this.distributionChannelList[i]
        }

        if (this.channelIdList.length > 0) {
          for (let i = 0; i < this.channelList.length; i++) {
            let position = this.channelIdList.indexOf(this.channelList[i].id)
            if (~position) {
              this.channelList[i].checked = true
            } else {
              this.channelList[i].checked = false
            }
          }
        }
      },
      productList (n, o) {
        // for (let i = 0; i < this.productGroupList.length; i++) {
        //   this.productGroupList[i].treeData = this.productTreeDataStructure(this.productList, i, this.productGroupList[i].skuIdList)
        // }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Monitorings/MonitoringNew.vue